<template>
  <xmlTree :treeData="treeData" @shareNode="shareNodeChild" />
</template>

<script>
import { mapState } from 'vuex'
import xmlTree from './xmlTree.vue'
export default {
    name: "XmlTreeWrapper",
    components: {
        xmlTree
    },
    data() {
    return { treeData: []
    }
    },
    computed:{
        ...mapState(['xmlFile'])
    },
    methods:{
    loadXmlData() {
    fetch('/customerData/exampleData.xml') // Beispiel für das Laden der XML-Datei
        .then(response => response.text())
        .then(xmlText => {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(xmlText, "application/xml");
        const treeData = this.parseXml(xmlDoc.documentElement);
        this.treeData = [treeData]
        })
        .catch(error => console.error('Error loading XML:', error));
        
    },
    loadXmlData() {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(this.xmlFile, "application/xml");
        const treeData = this.parseXml(xmlDoc.documentElement);
        this.treeData = [treeData]
    },
    parseXml(xmlNode, currentPath = '') {
    const nodeName = xmlNode.nodeName;
    const newPath = `${currentPath}/${nodeName}`;
    const children = Array.from(xmlNode.children).map(childNode => this.parseXml(childNode, newPath));
    return {
        name: nodeName, // Der Knotenname
        expanded: false, // Anfangs geschlossen
        children: children, // Rekursiv die Kindknoten parsen
        xpath: newPath, // XPath
        value: xmlNode.children.length === 0 ? (xmlNode.textContent? xmlNode.textContent : undefined) : null // Wert des Endknotens
    };
    },
    shareNodeChild(node){
        this.$emit('shareNodeModal', node)
    }
    },
beforeMount() {
    this.loadXmlData(); // Daten werden beim Laden der Komponente initialisiert
},

}
</script>

<style>

</style>